export default __webpack_public_path__ + "static/media/feature-tool_tab_2.bf58b71e6ffef2b35991f9331159a7c5.svg";